import React from 'react'
import Button from '@mui/material/Button'
import { useMediaQuery } from '@mui/material'

type Props = Omit<React.ComponentProps<typeof Button>, 'variant'> & {
  variant?: 'principal' | 'secondary'
}

const stylesPrincipal = {
  backgroundColor: 'secondary.main',
  py: '10px',
  px:'16px',
  color: 'white',
  '&:hover': {
    backgroundColor: 'primary.main',
    boxShadow: 'none',
  },
}
const stylesSecondary = {
  backgroundColor: 'white',
  py: '10px',
  minHeight: '16px',
  border: '2px solid #444D4E',
  color: 'primary.main',
  '&:hover': {
    backgroundColor: 'primary.main',
    color: 'white',
    boxShadow: 'none',
  },
}
const CustomButton = ({ children, variant = 'principal', sx, ...rest }: Props) => {
  const isSmallMobile = useMediaQuery('(max-width: 480px)')
  const isMobile = useMediaQuery('(max-width: 800px)')
  
  return (
    <Button
      variant='contained'
      sx={{
        px: isSmallMobile ? '16px' : isMobile ? '24px' : '30px',
        fontWeight: '700',
        letterSpacing: '1px',
        borderRadius: '0px',
        boxShadow: 'none',
        fontSize: isSmallMobile ? '11px' : isMobile ? '12px' : '14px',
        minHeight: isSmallMobile ? '40px' : isMobile ? '44px' : '48px',
        lineHeight: isSmallMobile ? '14px' : '16px',
        ...(variant === 'principal' ? stylesPrincipal : stylesSecondary),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  )
}

export default CustomButton
